export default "__VITE_ASSET__D3JMUQ8o__"